<template>
  <a-spin :spinning="isLoading">
    <div class="reset-otp">
      <div class="title">{{ $t('i18n_reset') }}{{ $t('i18n_otp_title') }}</div>
      <div @keyup.enter="_handleResetOtp">
        <a-form-model ref="form" class="form" :rules="rules" :model="formData">
          <a-form-model-item :label="$t('i18n_reset_otp_device')" prop="name">
            <a-input
              ref="nameInput"
              v-model="formData.name"
              :placeholder="$t('i18n_input_name')"
              :max-length="20"
            />
          </a-form-model-item>
          <a-button type="primary" @click="_handleResetOtp">
            {{ $t('i18n_confirm') }}
          </a-button>
          <div class="reset-otp__back-otp-verify">
            <router-link :to="{ name: 'OtpVerify' }">
              {{ $t('i18n_back_to_verify_otp') }}
            </router-link>
          </div>
        </a-form-model>
      </div>
    </div>
  </a-spin>
</template>

<script>
import { name } from './utils'
import { getFormModelRule } from '@G/utils/other'

export default {
  name: 'OtpReset',
  data() {
    return {
      isLoading: false,
      isError: false,
      code: '',
      formData: {
        name: '',
        identityUUID: this.$route.params.identityUUID
      },
      rules: {
        name: [...getFormModelRule(name), { validator: this._handleCheckName }]
      }
    }
  },
  mounted() {
    this.$refs.nameInput.focus()
  },
  methods: {
    _handleResetOtp() {
      this.isError = false
      this.$refs.form.validate(async (error) => {
        if (error) {
          this.isLoading = true
          const { isError, toLink, code } = await this.$authProvider.resetOtp(
            this.formData
          )
          if (isError) {
            this.isError = true
            this.code = code
            this.$refs.form.validate(() => {})
          } else {
            this.$router.push({ name: toLink })
          }
          this.isLoading = false
        }
      })
    },
    _handleCheckName(rule, value, callback) {
      if (this.isError) {
        callback(this.$t(`i18n_code_${this.code}`))
      } else {
        callback()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@THEME_VARS';

.reset-otp {
  &__back-otp-verify {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 40px;
    a {
      color: $gray4;
      &::before {
        content: '\2022';
        color: $gray4;
      }
    }
  }
}
</style>
